<template>
  <div>
    <div class="content">
      <div class="title">
        <span>支付信息</span>
      </div>
      <ul>
        <li>
          <span>医院：</span>
          <span>{{ orderInfo.subjectName }}</span>
        </li>
        <li>
          <p>
            <span>处方号：</span>
            <span>{{ orderInfo.medicalAdviceCode }}</span>
          </p>
        </li>
        <li>
          <div>
            <p>
              <span>姓名：</span>
              <span>{{ orderInfo.patientName }}</span>
            </p>
            <p>
              <span>类型：</span>
              <!-- <span v-if="orderInfo.adviceType === 4">预交费</span> -->
              <span>营养医嘱</span>
              <!-- <span v-if="orderInfo.adviceType === 6">宣教医嘱</span> -->
            </p>
          </div>
        </li>
      </ul>
      <div>
        <div class="totalContent">
          <p class="title">处方支付金额</p>
          <p>
            <span style="color: var(--basic-green)">金额：</span>
            <span>￥{{ orderInfo.totalAmount || 0 }}</span>
            <span
                v-if="orderInfo.orderStatus === 1"
                style="color: var(--basic-red)"
            >
              未缴费
            </span>
            <span
                v-if="orderInfo.orderStatus === 2"
                style="color: var(--basic-red)"
            >
              支付中
            </span>
            <span
                v-if="orderInfo.orderStatus === 3"
                style="color: var(--basic-green)"
            >
              已支付
            </span>
            <span v-if="orderInfo.orderStatus === 4">退款中</span>
            <span v-if="orderInfo.orderStatus === 5">已退款</span>
          </p>
        </div>
        <div class="btnContent">
          <van-button
              v-if="orderInfo.orderStatus === 1"
              @click="payment"
              round
              size="small"
              type="success"
          >
            立即支付
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { reactive, toRefs } from "vue";

import { useRoute } from "vue-router";
import moment from "moment/moment";
import {requestPrescriptionNoWifi} from "../../api/prescription/prescription";

export default {
  mounted() {


  },
  methods: {

  },
  setup() {
    const route = useRoute();
    const state = reactive({
      orderInfo: "",
      medicalAdviceCode: route.query.adviceCode,
      category: route.query.category,
      content: route.query.c,
      code: route.query.o,
    });

    // 获取支付信息接口
    requestPrescriptionNoWifi({
      c: state.content,
      o: state.code,
      adviceCode: state.medicalAdviceCode
    }).then((v) => {
      const { data } = v;
      state.orderInfo = data;
      state.paymentAddress = data.paymentUrl;
      state.orderInfo.createTime = moment(state.orderInfo.createTime).format(
          "YYYY-MM-DD HH:mm:ss"
      );
      state.orderInfo.totalAmount = state.orderInfo.totalAmount.toFixed(2);
    });
    // 支付方法
    const payment = () => {
      console.log(state.paymentAddress);
      window.location.href = state.paymentAddress;
    };

    return {
      ...toRefs(state),
      payment,
      requestPrescriptionNoWifi,
    };
  },
};
</script>
<style lang="scss" scoped>
.content {
  border: 1px solid var(--basic-border-color);
  border-top: none;

  .totalContent {
    .title {
      opacity: 0.5;
    }

    p:last-of-type {
      background: var(--basic-price);
      padding: 16px;
      // background: ;
      text-align: left;

      span {
        font-size: 17px;
        display: inline-block;
        width: 32%;
      }
    }
  }

  .title {
    height: 40px;
    padding-left: 10px;
    line-height: 40px;
    border-bottom: 1px solid var(--basic-border-color);

    span {
      padding: 2px 10px;
      border-radius: 10px;
      color: #fff;
      font-size: 12px;
      background: var(--basic-green);
    }
  }

  ul {
    li {
      padding: 16px;
      border-bottom: 1px solid var(--basic-border-color);

      span:first-of-type {
        color: var(--basic-labe);
      }

      div {
        p {
          display: inline-block;
          width: 48%;
        }

        p:last-of-type {
          border: none;
          padding-left: 10px;
        }
      }
    }
  }
}

.btnContent {
  padding: 20px 20px 0 20px;
  text-align: center;

  button {
    width: 50%;
    display: block;
    margin: 0 auto;
    margin-bottom: 10px;
  }
}

.seeInfoContent {
  padding: 10px 20px 20px 20px;
  text-align: center;

  button {
    width: 50%;
    display: block;
    margin: 0 auto;
    margin-bottom: 10px;
  }
}
</style>
